<div class="container-fluid text-center whiteBackground" (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="row pb-3">
        <div class="col-lg-6" style="padding-top:70px; padding-bottom:3%; text-align: right">
            <h3 style="width: 100%;"><img class="productImageDimensions" [src]="this.imageName"
                    id="imageMain" alt="fertilizer image"></h3>
            <!-- thumbnails -->
            <h3 class="row" style="max-width:450pt; margin-right:1%; float:right">
                <img style="width:110px;margin-top:3%; " *ngFor="let row of dotComService.productAlternateItems"
                    src={{row.ExtendedDescription}} id={{row.ImageID}} (click)="ChangeImage(row)"
                    alt="fertilizer image">
            </h3>
        </div>
        <div class="col-lg" style="padding-top:70px; text-align: left; max-width:450px">
            <h3 class="DINNextLTPro-Black greenText" style="font-size:43px">{{dotComService.product.WebName |
                uppercase}}
            </h3>
            <h6 class="DIN2014Regular blackText" style="font-size:16px; line-height: 19px; text-transform: capitalize;">
                {{dotComService.product.ItemNmbr}}
            </h6>
            <h3 class="DIN2014Regular blackText"
                style="max-width:450pt;font-size:19px; line-height: 24px; font-weight: 600; word-spacing: .38px; text-align: justify;"
                [innerHTML]="dotComService.product.WebDescription"></h3>
            <h3 class="lightBlueBackground findRepButton" *ngIf="!this.myHarrellsService.onlineOrderingInEffect">
                <a class="DINNextLTPro-Black blueText"
                    style="line-height:2; font-size:20px; text-decoration: none !important" href='/findrep'>FIND MY
                    REP</a>
            </h3>
            <h3 class="greenBackground inquireButton " *ngIf="!this.myHarrellsService.onlineOrderingInEffect">
                <a class="DINNextLTPro-Black whiteText"
                    style="line-height:2; font-size:20px; text-decoration: none !important"
                    href='mailto:contact@harrells.com?subject={{dotComService.product.WebName}}'>INQUIRE ABOUT THIS
                    PRODUCT</a>
            </h3>
            <!-- extended desc -->

            <h3 *ngIf="dotComService.product.ExtendedDescription != ''" class="DIN2014Bold blackText"
                style="max-width:450pt;margin-top:20px; margin-bottom:1.5%; border-top:solid 1px grey"></h3>
            <div *ngIf="dotComService.product.ExtendedDescription != ''" style="max-width: 450px;">
                <h3 class="Caecilia76BoldItalic blackText"
                    style="display:inline-block;max-width:440pt;margin-top:20px; margin-bottom:20px; font-size:19px;">
                    Description
                </h3>
                <h3 (click)="ToggleDescription('close')" *ngIf="this.descriptionOpen==true"
                    style="float:right; display:inline; text-align: right; margin-top:-5px;">-</h3>
                <h3 (click)="ToggleDescription('open')" *ngIf="this.descriptionOpen==false"
                    style="float:right; display:inline; text-align: right; margin-top:-5px;">+</h3>
            </div>
            <h3 *ngIf="this.descriptionOpen==true" class="DIN2014Regular blackText"
                style="font-size:16px; line-height:22px; text-align:justify; text-transform:capitalize;margin-bottom:20px"
                [innerHTML]="dotComService.product.ExtendedDescription"></h3>
            <!-- extended desc end -->
            <!-- product sizes avaialble -->
            <h3 *ngIf="dotComService.productLinkedItems.length>0" class="DIN2014Bold blackText"
                style="max-width:450pt;margin-top:1.5%; margin-bottom:1.5%; border-top:solid 1px grey"></h3>
            <div *ngIf="dotComService.productLinkedItems.length>0"
                style="max-width: 450pt;margin-top:20px; margin-bottom:20px">
                <h3 class="Caecilia76BoldItalic blackText"
                    style="display:inline;max-width:440pt;margin-top:1.5%; margin-bottom:1.5%; font-size:19px;">Sizes
                </h3>
                <h3 (click)="ToggleSizes('close')" *ngIf="this.sizesOpen==true"
                    style="float:right; display:inline; text-align: right; margin-top:-5px;">-</h3>
                <h3 (click)="ToggleSizes('open')" *ngIf="this.sizesOpen==false"
                    style="float:right; display:inline; text-align: right; margin-top:-5px;">+</h3>
            </div>
            <ul *ngIf="this.sizesOpen==true">
                <li *ngFor="let row of dotComService.productLinkedItems" class="DIN2014Regular blackText"
                    style="font-size:16px; line-height:24px; text-transform:uppercase; max-width:450pt">
                    {{row.SellUofM}}
                </li>
            </ul>
            <!-- product sizes avaialble end -->
            <!-- sds/label buttons -->
            <h3 class="DIN2014Bold blackText" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
                style="max-width:450pt; margin-top:20px; border-top:solid 1px grey"></h3>
            <button class="DIN2014Bold blueBackground whiteText" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
                style="width:90px; border:none; font-size:20px; line-height: 2; text-decoration: none !important;margin-top:20px; margin-bottom:20px"
                (click)="DisplayLabelPDF(dotComService.product.ItemNmbr)">LABEL</button>
            <button class="DIN2014Bold blueBackground whiteText" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
                style="width:90px; border:none; margin-left:10px; font-size:20px; line-height: 2; text-decoration: none !important;margin-top:20px; margin-bottom:20px"
                (click)="DisplaySDSPDF(dotComService.product.ItemNmbr)">SDS</button>
            <!-- sds/label buttons end -->

            <div *ngIf="this.myHarrellsService.onlineOrderingInEffect">
                <h3 class="DIN2014Bold blackText"
                    style="max-width:450pt;margin-top:1.5%; margin-bottom:1.5%; border-top:solid 1px grey"></h3>

                <input Class="DIN2014Regular" [(ngModel)]="this.quantity"
                    (keypress)="dotComService.mustBeDigitNoPeriods($event)" (blur)="QtyLostFocus()"
                    style="display:inline;font-size:19px;line-height:30px;height:48px;width:120px;padding-left:5%; padding-right:5%"
                    placeholder="Enter Quantity">
                <img src="{{this.baseImagePaths + 'plus.png'}}" (click)="AdjustQuantity('up')" style="margin-left:10px"
                    alt="fertilizer image">
                <img src="{{this.baseImagePaths + 'minus.png'}}" (click)="AdjustQuantity('down')"
                    style="margin-left:10px" alt="fertilizer image">
                <h3 class="DIN2014Regular blackText"
                    style="display:inline-block;margin-left:10px; margin-top:10px;font-size:19px;">{{qtyText}}
                </h3>

                <button class="DIN2014Bold blueBackground whiteText mt-3"
                    style="width:100%; border:none; font-size:20px; line-height: 2; text-decoration: none !important"
                    (click)="AddToCart()">ADD TO CART</button>
                <button class="DIN2014Bold blueBackground whiteText mt-1"
                    style="width:100%; border:none; font-size:20px; line-height: 2; text-decoration: none !important"
                    (click)="GoToCart()">VIEW CART</button>
                <button class="DIN2014Bold blueBackground whiteText mt-1"
                    style="width:100%; border:none; font-size:20px; line-height: 2; text-decoration: none !important"
                    (click)="ContinueShopping()">CONTINUE SHOPPING</button>
            </div>

        </div>
    </div>
</div>

<!-- related images if any are configured - test with item hydroinj2.5 -->
<div class="row cremeBackground" style="padding-top:70px; padding-bottom:70px;text-align: center; padding-left:20px"
    *ngIf="this.relatedImage1ItemNmbr != '' ||  this.relatedImage2ItemNmbr != '' || this.relatedImage3ItemNmbr != '' || this.relatedImage4ItemNmbr != ''">
    <div class="row justify-content-lg-center">
        <div class="row text-align-start" style="width:1000px; text-align: left;">
            <h3 class="Caecilia76BoldItalic blackText"
                style="font-size:28px; font-weight:700; display:inline; margin-bottom:1.5%; ">Related Products</h3>
        </div>

        <div class="row cremeBackground  justify-content-lg-center" style="padding-left:20px">
            <div *ngIf="this.relatedImage1ItemNmbr != ''" style="width:235px; margin-right:20px">
                <div (click)="this.ViewRelatedProductDetail(this.relatedImage1ItemNmbr)" style="text-align: left">
                    <img style="width:236px; height:235px;"
                        src="{{this.productImagePaths + this.relatedImage1ItemNmbr + '.jpg'}}" alt="fertilizer image">
                    <h5 class="DIN2014Regular"
                        style="margin-top:12px; font-size:21px; line-height: 26px; font-weight:400">
                        {{this.relatedImage1ProductName | uppercase}}</h5>
                    <!-- <h5 class="DIN2014Regular" style="font-size:21px; line-height: 26px;">{{this.relatedImage1ItemNmbr}}
                    </h5> -->
                    <button class="DIN2014Regular greenBackground whiteText"
                        style="border:none; margin-top:16px; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">DETAILS</button>
                </div>
            </div>
            <div *ngIf="this.relatedImage2ItemNmbr != ''" style="width:235px; margin-right:20px">
                <div (click)="this.ViewRelatedProductDetail(this.relatedImage2ItemNmbr)" style="text-align: left">
                    <!-- <img style="width:16vw; height:16vw" -->
                    <img style="width:235px; height:235px;"
                        src="{{this.productImagePaths + this.relatedImage2ItemNmbr + '.jpg'}}" alt="fertilizer image">
                    <h5 class="DIN2014Regular"
                        style="margin-top:12px; font-size:21px; line-height: 26px; font-weight:400">
                        {{this.relatedImage2ProductName | uppercase}}</h5>
                    <!-- <h5 class="DIN2014Regular" style="font-size:21px; line-height: 26px; font-weight:400">{{this.relatedImage2ItemNmbr}}</h5> -->
                    <button class="DIN2014Regular greenBackground whiteText"
                        style="border:none; margin-top:16px; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">DETAILS</button>
                </div>
            </div>
            <div *ngIf="this.relatedImage3ItemNmbr != ''" style="width:235px; margin-right:20px">
                <div (click)="this.ViewRelatedProductDetail(this.relatedImage3ItemNmbr)" style="text-align: left">
                    <img style="width:235px; height:235px;"
                        src="{{this.productImagePaths + this.relatedImage3ItemNmbr + '.jpg'}}" alt="fertilizer image">
                    <h5 class="DIN2014Regular"
                        style="margin-top:12px; font-size:21px; line-height: 26px; font-weight:400">
                        {{this.relatedImage3ProductName | uppercase}}</h5>
                    <!-- <h5 class="DIN2014Regular" style="font-size:21px; line-height: 26px; font-weight:400">{{this.relatedImage3ItemNmbr}}</h5> -->
                    <button class="DIN2014Regular greenBackground whiteText"
                        style="border:none; margin-top:16px; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">DETAILS</button>
                </div>
            </div>
            <div *ngIf="this.relatedImage4ItemNmbr != ''" style="width:235px; ">
                <div (click)="this.ViewRelatedProductDetail(this.relatedImage4ItemNmbr)" style="text-align: left">
                    <img style="width:235px; height:235px;"
                        src="{{this.productImagePaths + this.relatedImage4ItemNmbr + '.jpg'}}" alt="fertilizer image">
                    <h5 class="DIN2014Regular"
                        style="margin-top:12px; font-size:21px; line-height: 26px; font-weight:400">
                        {{this.relatedImage4ProductName | uppercase}}</h5>
                    <!-- <h5 class="DIN2014Regular" style="font-size:21px; line-height: 26px; font-weight:400">{{this.relatedImage4ItemNmbr}}</h5> -->
                    <button class="DIN2014Regular greenBackground whiteText"
                        style="border:none; margin-top:16px; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">DETAILS</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="row text-center" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
    style="background-size: cover; background-position:center; padding-bottom:3%"
    [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern-full.png)'}">
    <h3 class="DINNextLTPro-Black whiteText"
        style="font-size:30px; line-height:44px; text-transform: uppercase; text-align: center; margin-top:3%">
        Harrell's is the exclusive United States owner,<br> formulator and distributor of POLYON® controlled-<br>release
        fertilizer.</h3>
    <h3 style="margin-top:3%"><a class="DIN2014Bold whiteBackground greenText"
            style="font-size:20PX ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT WITH YOUR
            REP</a>
    </h3>
</div> -->
<div
    [ngClass]="(this.relatedImage1ItemNmbr == '' &&  this.relatedImage2ItemNmbr == '' && this.relatedImage3ItemNmbr == '' && this.relatedImage4ItemNmbr == '')?'cremeBackground':''">
    <!-- <div class="row blackText text-center" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
        style="padding-top:80px;padding-bottom:70px; max-width: 1200px; margin: auto;">
        <div class="col-2"></div>
        <div class="col-lg-4 greenText" style="padding-right:40px; border-right:solid 1px black;">
            <h4 class="Caecilia76BoldItalic"
                style="opacity:100%;text-align: right; margin-left:20%; font-size:28px; line-height: 36px;">
                Take a Balanced<br>Approach to<br>Growth</h4>
            <h6 class="DIN2014Regular blackText"
                style="margin-top:3%; text-align:right; margin-left:19%; font-size:19px; line-height:30px">
                Harrell's Balanced Approach is a scientifically supported, integrated, and proactive use of agronomic
                resources to maximize plant health and consistency.</h6>
        </div>
        <div class="col-lg-4">
            <div class="row">
                <div class="col-lg-6">
                    <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                            src="{{this.pageImagePaths + 'soil-icon.png'}}" alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">SOIL</h4>
                    <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                            style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'water-icon.png'}}"
                            alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">WATER</h4>
                </div>
                <div class="col-lg-6 secondSetofIcons">
                    <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                            src="{{this.pageImagePaths + 'nutrition-icon.png'}}" alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">NUTRITION</h4>
                    <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                            style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'protection-icon.png'}}"
                            alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">PROTECTION
                    </h4>
                </div>
            </div>
            <div class="row">
                <a href="/products" style="width:100%; display:inline;">
                    <h3 class="Caecilia76BoldItalic blackText"
                        style="font-size:16px; font-weight: 700; margin-top:25px; text-decoration: underline; ">
                        VIEW ALL PRODUCTS</h3>
                </a>
            </div>
        </div>
        <div class="col-2"></div>
    </div> -->

    <app-takeabalancedapproach></app-takeabalancedapproach>

    <div class="row blueBackground g-0" *ngIf="!this.myHarrellsService.onlineOrderingInEffect && !(this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
        <div class="col-9" style="padding-top:70px;">
            <h4 class="DIN2014Bold whiteText"
                style="text-align: LEFT; margin-left:20%; font-size:36px; line-height: 46px;">
                Don't grow it alone. Connect with Harrell's to harness the power of research, science, and support in
                ways you never thought possible.</h4>
        </div>
        <div class="col-3">
        </div>
    </div>
    <div class="row blueBackground" *ngIf="!this.myHarrellsService.onlineOrderingInEffect && !(this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')" style="padding-bottom:70px">
        <div class="col-9" style="padding-top:36px">
            <h3 class="connectWithRepBtn"><a class="DIN2014Bold whiteBackground greenText"
                    style="font-size:20PX ;padding:6px; text-decoration: none !important" href='/findrep'>CONNECT WITH
                    YOUR REP</a>
            </h3>
        </div>
    </div>